import{s}from"../classes/semver.js";const e=s;var r=(s,r,o)=>{const a=new e(s,o),c=new e(r,o);return a.compare(c)||a.compareBuild(c)};export{r as c};
